let curriculum = {};

export const setCurriculum = (newVersion) => { curriculum = newVersion; };

export const getCurriculum = () => curriculum;

export const getLevels = () => getCurriculum().levels;
export const getArticles = () => getCurriculum().articles;
export const getMasteryTiles = () => getCurriculum().masteryTiles;
export const getCharacters = () => getCurriculum().characters;
export const getOnboarding = () => getCurriculum().onboardingText;
export const getAvailableLevels = () => getCurriculum().availableLevels;
